module.exports = __webpack_public_path__ + "media/images/icons/remove-circle-79a3426b29c3f46ae7ac8bff0fc8b0ac.svg";